import { Link } from 'react-router-dom';
import { Button } from '../../../components/Button';

interface MobileGateProps {
  /** 由页面持有的绕过回调（写入 sessionStorage 并立即重新渲染） */
  onBypass: () => void;
}

/**
 * 单机管理在移动端的拦截页。
 *
 * 这一页是硬实时界面：姿态球、大数字、告警条幅需要横向空间，手机上无论怎么排版
 * 都无法同时满足「可读」和「不误触」，因此直接不渲染内容，只给出替代入口。
 * 需要临时查看时可以通过「强制渲染」按钮绕过（仅本次会话有效），
 * 绕过后面板按电脑端固定排版渲染，不做移动端适配。
 */
export function MobileGate({ onBypass }: MobileGateProps) {
  return (
    <div className="flex min-h-full items-center justify-center bg-surface-0 px-4 py-8">
      <div className="w-full max-w-md rounded-xl border border-line bg-surface-1 p-6">
        <div className="flex items-center gap-2">
          <span aria-hidden className="size-2.5 rounded-full bg-warning" />
          <h1 className="text-lg font-bold text-fg">单机管理不支持移动端</h1>
        </div>

        <p className="mt-3 text-sm leading-relaxed text-fg-muted">
          单机管理是硬实时监控界面，需要同时展示姿态球、大数字遥测与告警条幅。
          手机与平板的屏幕宽度不足，任何排版都会导致关键参数被挤压或误触，
          因此本页在移动端停止渲染内容。
        </p>

        <ul className="mt-3 flex flex-col gap-1.5 text-sm text-fg-muted">
          <li>· 请在电脑端（建议宽度 ≥ 1280 px）打开本页面。</li>
          <li>· 手机上可先使用「总览」与「无人机管理」查看设备与配置。</li>
          <li>· 需要现场临时查看时，可用下方按钮强制渲染电脑端界面。</li>
        </ul>

        <div className="mt-5 flex flex-col gap-2 sm:flex-row">
          <Link to="/fleet" className="sm:flex-1">
            <Button block variant="primary">
              前往总览
            </Button>
          </Link>
          <Link to="/fleet/drones" className="sm:flex-1">
            <Button block>无人机管理</Button>
          </Link>
        </div>

        <div className="mt-5 border-t border-line pt-4">
          <Button block variant="ghost" onClick={onBypass}>
            强制渲染电脑端界面（本次会话有效）
          </Button>
          <p className="mt-2 text-[11px] leading-relaxed text-fg-subtle">
            强制渲染后界面按电脑端固定排版显示，不会针对移动端做适配。
            刷新或关闭标签页后恢复拦截。
          </p>
        </div>
      </div>
    </div>
  );
}
